<template>
  <div class="medicine-stock-form">
    <v-app>
      <b-form @submit.stop.prevent="formOnsubmit">
        <section class="medicine-stock-form__section">
          <div class="medicine-stock-form__heading">
            <div class="medicine-stock-form__icon"><i class="fas fa-exchange-alt"></i></div>
            <div>
              <h4>Informasi transaksi</h4>
              <p>Tentukan jenis pergerakan, obat, dan jumlah stok.</p>
            </div>
          </div>

          <div class="medicine-stock-form__grid">
            <b-form-group id="input-group-stock-in-out" label="Jenis Stok:" label-for="input-stock-in-out">
              <b-form-select
                id="input-stock-in-out"
                v-model="form.stock_in_out"
                :options="options"
                @input="setFormStockInOut"
              ></b-form-select>
              <small class="text-danger">{{ error.stock_in_out }}</small>
            </b-form-group>

            <b-form-group id="input-group-trigger-modal-medicine" label="Obat dan Alkes:" label-for="input-trigger-modal-medicine">
              <b-form-input
                id="input-trigger-modal-medicine"
                v-model="display.medicine_name"
                placeholder="Pilih obat atau alkes"
                readonly
                @click="$bvModal.show('modal-medicine')"
              ></b-form-input>
              <small class="text-danger">{{ error.medicine_id }}</small>
            </b-form-group>

            <b-form-group id="input-group-quantity" label="Kuantitas:" label-for="input-quantity">
              <b-form-input
                id="input-quantity"
                v-model="form.quantity"
                type="number"
                min="0"
                inputmode="numeric"
                placeholder="Masukkan jumlah"
              ></b-form-input>
              <small class="text-danger">{{ error.quantity }}</small>
            </b-form-group>

            <b-form-group v-if="stock_in" id="input-group-ref-no">
              <label for="input-ref-no">No. Referensi <em class="text-muted">opsional</em></label>
              <b-form-input id="input-ref-no" v-model="form.ref_no" placeholder="Contoh: INV-2026-001"></b-form-input>
              <small class="text-danger">{{ error.ref_no }}</small>
            </b-form-group>
          </div>
        </section>

        <section v-if="stock_in" class="medicine-stock-form__section">
          <div class="medicine-stock-form__heading">
            <div class="medicine-stock-form__icon"><i class="fas fa-tags"></i></div>
            <div>
              <h4>Harga dan pemasok</h4>
              <p>Catat nilai pembelian agar HPP dan riwayat supplier akurat.</p>
            </div>
          </div>

          <div class="medicine-stock-form__grid medicine-stock-form__grid--three">
            <b-form-group id="input-group-hna" label="Harga Netto Apotek:" label-for="input-hna">
              <b-form-input id="input-hna" v-model="formatedHna" inputmode="numeric" placeholder="Rp 0"></b-form-input>
              <small class="text-danger">{{ error.hna }}</small>
            </b-form-group>

            <b-form-group id="input-group-discount" label="Diskon (%):" label-for="input-discount">
              <b-form-input id="input-discount" v-model="form.discount" type="number" min="0" max="100" @keyup="inputDiscountKeyup"></b-form-input>
              <small class="text-danger">{{ error.discount }}</small>
            </b-form-group>

            <b-form-group id="input-group-ppn" label="PPN (%):" label-for="input-ppn">
              <b-form-input id="input-ppn" v-model="form.ppn" type="number" min="0" max="100" @keyup="inputPpnKeyup"></b-form-input>
              <small class="text-danger">{{ error.ppn }}</small>
            </b-form-group>

            <b-form-group id="input-group-vendor" class="medicine-stock-form__wide">
              <label>Supplier <em class="text-muted">opsional</em></label>
              <treeselect v-model="form.vendor_id" :multiple="false" :options="vendors" placeholder="Pilih supplier" />
              <small class="text-danger">{{ error.vendor_id }}</small>
            </b-form-group>
          </div>
        </section>

        <section v-if="stock_in" class="medicine-stock-form__section medicine-stock-form__section--batch">
          <div class="medicine-stock-form__heading">
            <div class="medicine-stock-form__icon"><i class="fas fa-boxes"></i></div>
            <div>
              <h4>Batch dan lokasi penyimpanan</h4>
              <p>Total jumlah seluruh batch tidak boleh melebihi kuantitas transaksi.</p>
            </div>
          </div>

          <div class="medicine-stock-form__batch-grid">
            <div>
              <label for="input-batch-no">No. Batch</label>
              <b-form-input id="input-batch-no" v-model="batch_collection_form.batch_no" placeholder="No. batch"></b-form-input>
              <small class="text-danger">{{ error_batch.batch_no }}</small>
            </div>
            <div>
              <label for="input-quantity-batch">Jumlah</label>
              <b-form-input id="input-quantity-batch" v-model="batch_collection_form.first_quantity" type="number" min="0" inputmode="numeric" placeholder="0"></b-form-input>
              <small class="text-danger">{{ error_batch.first_quantity }}</small>
            </div>
            <div>
              <label>Gudang</label>
              <treeselect v-model="batch_collection_form.warehouse" :multiple="false" :options="warehouse" placeholder="Pilih gudang" />
              <small class="text-danger">{{ error_batch.warehouse_id }}</small>
            </div>
            <div v-if="warehouseChoosed">
              <label>Rak</label>
              <treeselect v-model="batch_collection_form.rack" :multiple="false" :options="rack" placeholder="Pilih rak" />
              <small class="text-danger">{{ error_batch.rack_id }}</small>
            </div>
            <div>
              <label for="input-expired">Tanggal Kedaluwarsa</label>
              <v-dialog ref="dialog" v-model="modal2" :return-value.sync="batch_collection_form.expired" persistent width="350px">
                <template v-slot:activator="{ on, attrs }">
                  <b-input-group>
                    <b-input-group-prepend>
                      <button class="btn btn-secondary" type="button" v-bind="attrs" v-on="on" aria-label="Pilih tanggal kedaluwarsa">
                        <i class="fas fa-calendar"></i>
                      </button>
                    </b-input-group-prepend>
                    <b-form-input id="input-expired" v-model="batch_collection_form.expired" placeholder="YYYY-MM-DD" @input="formaterDate"></b-form-input>
                  </b-input-group>
                </template>
                <v-date-picker v-if="modal2" v-model="batch_collection_form.expired" locale="id">
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="modal2 = false">Batal</v-btn>
                  <v-btn text color="primary" @click="$refs.dialog.save(batch_collection_form.expired)">Pilih</v-btn>
                </v-date-picker>
              </v-dialog>
              <small class="text-danger">{{ error_batch.expired }}</small>
            </div>
            <b-button class="medicine-stock-form__add-batch" variant="info" type="button" @click="setBatch">
              <i class="fas fa-plus mr-2"></i>Tambah Batch
            </b-button>
          </div>

          <div class="table-responsive medicine-stock-form__table">
            <table class="table mb-0">
              <thead>
                <tr><th>No. Batch</th><th>Jumlah</th><th>Gudang / Rak</th><th>Kedaluwarsa</th><th class="text-center">Aksi</th></tr>
              </thead>
              <tbody>
                <tr v-for="btc in batch_collection" :key="btc.batch_no">
                  <td><strong>{{ btc.batch_no }}</strong></td>
                  <td>{{ btc.first_quantity }}</td>
                  <td>{{ btc.rack_name ? btc.warehouse_name + " - " + btc.rack_name : btc.warehouse_name }}</td>
                  <td>{{ btc.expired }}</td>
                  <td class="text-center">
                    <b-button size="sm" variant="outline-danger" title="Hapus batch" type="button" @click="removeBatch(btc.batch_no)"><i class="fas fa-trash px-0"></i></b-button>
                  </td>
                </tr>
                <tr v-if="batch_collection.length === 0">
                  <td colspan="5" class="medicine-stock-form__empty">Belum ada batch ditambahkan.</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        <section class="medicine-stock-form__section">
          <b-form-group id="input-group-notes" class="mb-0">
            <label for="input-notes">Catatan <em class="text-muted">opsional</em></label>
            <b-form-textarea id="input-notes" v-model="form.notes" placeholder="Tambahkan keterangan transaksi bila diperlukan" rows="3" max-rows="5"></b-form-textarea>
            <small class="text-danger">{{ error.notes }}</small>
          </b-form-group>
        </section>

        <div class="medicine-stock-form__actions">
          <b-button type="submit" variant="primary"><i class="fas fa-save mr-2"></i>Simpan Transaksi</b-button>
          <b-button variant="default" @click="$router.push('/medicine/maintain-stock')">Batal</b-button>
        </div>
      </b-form>
      <ModalMedicine
        @chosenMedicine="setMedicine"
        secondPurpose="medicineStock"
        :isAbjad="true"
      />
    </v-app>
  </div>
</template>

<script>
import Card from "@/view/content/Card.vue";
import module from "@/core/modules/CrudModule.js";
import validation from "@/core/modules/ValidationModule.js";
import ModalMedicine from "@/component/general/ModalMedicine.vue";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  name: "Add",

  props: {
    form: Object,
    route: String,
  },

  components: {
    Card,
    ModalMedicine,
  },

  data() {
    return {
      // Display Data
      display: {
        medicine_name: "",
      },
      medicine: [],
      vendors: [],
      warehouse: [],
      rack: [],
      modal2: false,
      stock_in: true,
      // Error
      error: {
        medicine_id: null,
        medicine_name: "",
        stock_in_out: null,
        quantity: null,
        remaining_stock: null,
        price: null,
        vendor_id: null,
        vendor_name: null,
        notes: "",
        hna: "",
        ppn: "",
        discount: "",
        ref_no: "",
      },
      error_batch: {
        first_quantity: "",
        expired: "",
        warehouse_id: "",
        rack_id: "",
        batch_no: "",
      },
      options: [
        { value: null, text: "Pilih Jenis Stok", disabled: true },
        { value: 0, text: "Stok Masuk" },
        { value: 1, text: "Stok Keluar" },
      ],
      route_vendor: "",
      form_vendor: {
        medicine_id: this.form.medicine_id,
        vendor_id: this.form.vendor_id,
      },
      batch_collection: [],
      batch_collection_form: {
        batch_no: "",
        first_quantity: "",
        warehouse_id: [],
        rack_id: [],
        warehouse_name: "",
        rack_name: "",
        expired: "",
      },
      quantity_count: 0,
      warehouseChoosed: false,
    };
  },

  computed: {
    formatedHna: {
      set(newValue) {
        newValue = parseInt(newValue.replace(/\D/g, ""), 10);
        if (!Number.isNaN(newValue)) {
          this.form.hna = newValue.toLocaleString("id-ID");
        } else {
          this.form.hna = "";
        }
      },
      get() {
        return this.form.hna;
      },
    },
  },

  methods: {
    inputDiscountKeyup() {
      if (this.form.discount > 100) {
        this.form.discount = 100;
      } else if (this.form.discount < 0) {
        this.form.discount = 0;
      }
    },
    inputPpnKeyup() {
      console.log(this.form.ppn);
      if (this.form.ppn > 100) {
        this.form.ppn = 100;
        console.log("lebih", this.form.ppn);
      } else if (this.form.ppn < 0) {
        this.form.ppn = 0;
      }
    },
    formaterDate(val) {
      if (val.length == 4) {
        this.batch_collection_form.expired =
          this.batch_collection_form.expired + "-";
      }
      if (val.length == 7) {
        this.batch_collection_form.expired =
          this.batch_collection_form.expired + "-";
      }
    },

    formaterDate(val) {
      if (val.length == 4) {
        this.batch_collection_form.expired =
          this.batch_collection_form.expired + "-";
      }
      if (val.length == 7) {
        this.batch_collection_form.expired =
          this.batch_collection_form.expired + "-";
      }
    },

    setMedicine(value) {
      this.form.medicine_id = value.id;
      this.display.medicine_name = value.name;
      this.$bvModal.hide("modal-medicine");
    },

    async getMedicineOption() {
      let response = await module.setTreeSelect("medicines");
      // Success
      if (response.state == "success") {
        // Set Option Select
        this.medicine = response.data;
      }
    },
    async getVendorOption() {
      let response = await module.setTreeSelect("vendors");
      // Success
      if (response.state == "success") {
        // Set Option Select
        this.vendors = response.data;
      }
    },
    async getWarehouseOption() {
      let response = await module.setTreeSelect("warehouses");
      // Success
      if (response.state == "success") {
        // Set Option Select
        this.warehouse = response.data;
      }
    },
    async getRackOption(id) {
      let response = await module.setTreeSelect("warehouses-rack/" + id);
      // Success
      if (response.state == "success") {
        // Set Option Select
        this.rack = response.data;
        this.warehouseChoosed = true;
      }
    },

    setFormStockInOut() {
      if (this.stock_in == true) {
        this.stock_in = false;
      } else if (this.stock_in == false) {
        this.stock_in = true;
      }
    },

    resetBatchForm() {
      // Object.keys(this.batch_collection_form).forEach(function (key, index) {
      //     this.batch_collection_form[key] = "";
      // });
      this.batch_collection_form.first_quantity = "";
      this.batch_collection_form.expired = "";
      this.batch_collection_form.batch_no = "";
      this.batch_collection_form.warehouse_id = null;
      this.batch_collection_form.rack_id = null;

      this.batch_collection_form.warehouse_name = null;
      this.batch_collection_form.rack_name = null;

      this.batch_collection_form.warehouse = null;
      this.batch_collection_form.rack = null;
    },

    async setBatch() {
      if (
        this.batch_collection_form.first_quantity == "" ||
        this.batch_collection_form.expired == "" ||
        this.batch_collection_form.batch_no == "" ||
        this.batch_collection_form.warehouse == "" ||
        this.batch_collection_form.rack == ""
      ) {
        if (this.batch_collection_form.first_quantity == "") {
          this.error_batch.first_quantity = "Jumlah tiap batch harus diisi";
        }
        if (this.batch_collection_form.batch_no == "") {
          this.error_batch.batch_no = "Nomer batch harus diisi";
        }
        if (this.batch_collection_form.expired == "") {
          this.error_batch.expired = "Tanggal kadaluarsa harus diisi";
        }
      } else {
        this.error_batch.first_quantity = "";
        this.error_batch.batch_no = "";
        this.error_batch.expired = "";
        this.error_batch.warehouse_id = "";

        if (this.batch_collection.length == 0) {
          // if batch == null

          this.quantity_count =
            this.quantity_count +
            parseInt(this.batch_collection_form.first_quantity);

          //if quantity was correct

          if (this.quantity_count <= this.form.quantity) {
            //  get warehouse and rack data
            let response = await module.get(
              `warehouses/${this.batch_collection_form.warehouse}`
            );
            this.batch_collection_form.warehouse_id =
              this.batch_collection_form.warehouse;
            this.batch_collection_form.warehouse_name = response.name;


            if (typeof this.batch_collection_form.rack != "undefined" || this.batch_collection_form.rack != null) {
              let resRack = await module.get(
                `warehouses-rack/by-id/${this.batch_collection_form.rack}`
              );
              this.batch_collection_form.rack_id =
                this.batch_collection_form.rack;
              this.batch_collection_form.rack_name = resRack.name;
            } else {
              this.batch_collection_form.rack_id = "";
              this.batch_collection_form.rack_name = "";
            }

            // concate data json batch
            let clone = { ...this.batch_collection_form };

            this.batch_collection.push(clone);

            // reset data batch on form
            this.resetBatchForm();
          } else {
            Swal.fire({
              title: "Gagal",
              text: "Jumlah stok batch tidak boleh melebihi kuantitas obat",
              icon: "warning",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            this.quantity_count =
              this.quantity_count -
              parseInt(this.batch_collection_form.first_quantity);
          }
        } else {
          // if already have data on array batch

          let a;
          for (a = 0; a < this.batch_collection.length; a++) {
            if (
              this.batch_collection_form.batch_no ==
              this.batch_collection[a].batch_no
            ) {
              Swal.fire({
                title: "Gagal",
                text: "Batch No Tidak Boleh Sama",
                icon: "warning",
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              });
            } else {
              // this.form.quantity = parseInt(this.form.quantity) + parseInt(this.batch_collection_form.first_quantity)
              this.quantity_count =
                this.quantity_count +
                parseInt(this.batch_collection_form.first_quantity);

              // if quantity correct
              if (this.quantity_count <= this.form.quantity) {
                // get warehouse and rack data
                let response = await module.get(
                  `warehouses/${this.batch_collection_form.warehouse}`
                );
                this.batch_collection_form.warehouse_id =
                  this.batch_collection_form.warehouse;
                this.batch_collection_form.warehouse_name = response.name;


                if (typeof this.batch_collection_form.rack != "undefined" || this.batch_collection_form.rack != null) {
                  let resRack = await module.get(
                    `warehouses-rack/by-id/${this.batch_collection_form.rack}`
                  );
                  this.batch_collection_form.rack_id =
                    this.batch_collection_form.rack;
                  this.batch_collection_form.rack_name = resRack.name;
                } else {
                  this.batch_collection_form.rack_id = "";
                  this.batch_collection_form.rack_name = "";
                }

                // concate data json batch
                let clone = { ...this.batch_collection_form };
                this.batch_collection.push(clone);

                // reset data on form
                this.resetBatchForm();
                break;
              } else {
                Swal.fire({
                  title: "Gagal",
                  text: "Jumlah stok batch tidak boleh melebihi kuantitas obat",
                  icon: "warning",
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                  timerProgressBar: true,
                });
                this.quantity_count =
                  this.quantity_count -
                  parseInt(this.batch_collection_form.first_quantity);
              }
            }
          }
        }
      }

    },
    removeBatch($id) {
      let a;
      for (a = 0; a < this.batch_collection.length; a++) {
        if (this.batch_collection[a].batch_no == $id) {
          this.quantity_count =
            this.quantity_count -
            parseInt(this.batch_collection[a].first_quantity);

          this.batch_collection.splice(a, 1);
        }
      }
    },

    async formOnsubmit() {
      if (this.stock_in == true) {
        if (this.batch_collection.length == 0) {
          Swal.fire({
            title: "Gagal",
            text: "Batch Masih Kosong",
            icon: "warning",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        } else {
          this.form.batch = this.batch_collection;

          // Make Request
          let response = await module.submit(this.form, this.route);

          // Check Response
          if (response.state == "error") {
            this.error = validation.setValidationError(
              this.error,
              response.error.errors
            );
          } else {
            Swal.fire(
              response.success.title,
              response.success.message,
              "success"
            );
            this.$router.push("/medicine/maintain-stock");
          }
        }
      } else if (this.stock_in == false) {
        // Make Request
        let response = await module.submit(this.form, this.route);

        // Check Response
        if (response.state == "error") {
          this.error = validation.setValidationError(
            this.error,
            response.error.errors
          );
        } else {
          Swal.fire(
            response.success.title,
            response.success.message,
            "success"
          );
          this.$router.push("/medicine/maintain-stock");
        }
      }
    },
  },

  mounted() {
    this.getMedicineOption();
    this.getVendorOption();
    this.getWarehouseOption();
  },
  watch: {
    "form.medicine_name": function (newVal, oldVal) {
      this.display.medicine_name = newVal;
    },
    "batch_collection_form.warehouse": function (newVal) {
      this.batch_collection_form.warehouse = newVal;
      this.getRackOption(newVal);
    },
    "batch_collection_form.rack": function (newVal) {
      this.batch_collection_form.rack = newVal;
    },
  },
};
</script>

<style scoped>
.medicine-stock-form {
  color: #33475b;
}

.medicine-stock-form__section {
  margin-bottom: 18px;
  padding: 18px;
  border: 1px solid #dfe8ee;
  border-radius: 13px;
  background: #fff;
}

.medicine-stock-form__heading {
  display: flex;
  align-items: center;
  gap: 11px;
  margin-bottom: 16px;
  padding-bottom: 13px;
  border-bottom: 1px solid #e7eef3;
}

.medicine-stock-form__heading h4,
.medicine-stock-form__heading p {
  margin: 0;
}

.medicine-stock-form__heading h4 {
  color: #1f3449;
  font-size: 14px;
  font-weight: 700;
}

.medicine-stock-form__heading p {
  margin-top: 3px;
  color: #718295;
  font-size: 11px;
}

.medicine-stock-form__icon {
  display: grid;
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  place-items: center;
  border-radius: 10px;
  color: #0f8881;
  background: #e7f6f4;
}

.medicine-stock-form__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 2px 18px;
}

.medicine-stock-form__grid--three {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.medicine-stock-form__grid > fieldset,
.medicine-stock-form__grid > .form-group {
  min-width: 0;
  margin-bottom: 14px;
}

.medicine-stock-form__wide {
  grid-column: 1 / -1;
}

.medicine-stock-form__batch-grid {
  display: grid;
  grid-template-columns: 1fr .7fr 1fr 1fr 1.25fr auto;
  gap: 12px;
  align-items: end;
}

.medicine-stock-form__batch-grid > div {
  min-width: 0;
}

.medicine-stock-form__batch-grid label {
  display: block;
  margin-bottom: 7px;
  color: #3f5266;
  font-size: 12px;
  font-weight: 600;
}

.medicine-stock-form__add-batch {
  min-width: 132px;
  height: 42px;
  margin-bottom: 1px;
  white-space: nowrap;
}

.medicine-stock-form__table {
  margin-top: 16px;
  overflow: hidden;
  border: 1px solid #e1e9ef;
  border-radius: 10px;
}

.medicine-stock-form__table th {
  border-top: 0;
  color: #607286;
  background: #f5f8fa;
  font-size: 10px;
  letter-spacing: .04em;
  text-transform: uppercase;
}

.medicine-stock-form__table td {
  vertical-align: middle;
}

.medicine-stock-form__empty {
  padding: 22px !important;
  color: #8493a3;
  text-align: center;
}

.medicine-stock-form__actions {
  display: flex;
  justify-content: flex-end;
  gap: 9px;
  padding-top: 2px;
}

@media (max-width: 1199.98px) {
  .medicine-stock-form__batch-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .medicine-stock-form__add-batch {
    width: max-content;
  }
}

@media (max-width: 767.98px) {
  .medicine-stock-form__section {
    padding: 14px;
  }

  .medicine-stock-form__grid,
  .medicine-stock-form__grid--three,
  .medicine-stock-form__batch-grid {
    display: block;
  }

  .medicine-stock-form__batch-grid > div {
    margin-bottom: 14px;
  }

  .medicine-stock-form__add-batch {
    width: 100%;
  }

  .medicine-stock-form__actions {
    flex-direction: column;
  }

  .medicine-stock-form__actions .btn {
    width: 100%;
  }
}
</style>
